export { GlobalErrorFallback } from './GlobalErrorFallback';
export { ErrorBoundary } from './GlobalErrorFallback';
export * as Styled from './GlobalErrorFallback.styles';
